import store from "@/store";
import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import api from "@/api";
import AuthModel from "@/models/AuthModel";
import UserModel from "@/models/UserModel";
import { ApplicationModule } from "@/store/modules/application";
import { HomeModule } from "@/store/modules/home";

export interface IUserState {
  authToken: string;
  userId: string;
  userDetail: UserModel;
}
@Module({ dynamic: true, store, name: "user" })
class User extends VuexModule {
  public authToken: string = localStorage.authToken || "";
  public userDetail: UserModel = new UserModel();

  @Mutation
  private SET_AUTH_TOKEN(authToken: string) {
    this.authToken = authToken;
  }

  @Mutation
  private SET_USER_DETAIL(userDetail: UserModel) {
    this.userDetail = userDetail;
  }

  @Action({ rawError: true })
  public Login(payload: AuthModel) {
    return new Promise((resolve, reject) => {
      api.auth
        .login(payload.email, payload.password, payload.firebase_token)
        .then((response) => {
          if (response.data.code === 200) {
            const authToken: string = response.data.data.jwt_token;
            localStorage.setItem("authToken", authToken);
            this.SET_AUTH_TOKEN(authToken);
            resolve(response);
          } else {
            ApplicationModule.showAlert({
              alertState: true,
              alertType: "error",
              alertMessage: response.data.message,
            });
            this.Logout();
            reject(new Error(response.data.message));
          }
        })
        .catch((err: any) => {
          ApplicationModule.showAlert({
            alertState: true,
            alertType: "error",
            alertMessage: err?.response?.data?.message,
          });
          reject(err);
          this.Logout();
        });
    });
  }
  @Action({ rawError: true })
  public LoadProfileUser() {
    return new Promise((resolve, reject) => {
      if (localStorage.authToken) {
        api.user.getUserDetail().then((response) => {
          if (response.data.code === 200) {
            this.SET_USER_DETAIL(response.data.data);
            resolve(response);
          } else {
            reject(new Error("Detail user tidak ditemukan"));
            this.Logout();
          }
        });
      } else {
        reject(new Error("Token Unavailable"));
        this.Logout();
      }
    });
  }

  @Action({ rawError: true })
  public Logout() {
    return new Promise<void>((resolve) => {
      localStorage.removeItem("authToken");
      this.SET_AUTH_TOKEN("");
      this.SET_USER_DETAIL(new UserModel());
      
      // Clear home page cache
      HomeModule.resetState();
      sessionStorage.removeItem("homeScrollPosition");
      sessionStorage.removeItem("homeCurrentPage");
      sessionStorage.removeItem("homeListTicket");
      sessionStorage.removeItem("homeHasMorePages");
      
      resolve();
    });
  }
}

export const UserModule = getModule(User);
